var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnterpriseGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000001"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m13.6731 2.64676c1.7196.30537 3.2786 1.07324 4.5453 2.17099.313.27128.7867.23743 1.058-.0756.2712-.31302.2374-.78669-.0756-1.05796-1.9292-1.6718-4.4477-2.68419-7.2008-2.68419-6.07513 0-11 4.92487-11 11 0 5.0558 3.4102 9.3132 8.05447 10.601.39915.1107.81245-.1232.92313-.5223.1107-.3992-.12316-.8125-.52232-.9232-3.85744-1.0696-6.72746-4.5122-6.94235-8.6555h4.75407c.09687 1.97.5386 3.8924 1.29153 5.6802.16077.3817.60056.5608.9823.4.38174-.1607.56087-.6005.40009-.9823-.67577-1.6045-1.07642-3.3292-1.17193-5.0979h.48101c.41421 0 .75-.3358.75-.75s-.33579-.75-.75-.75h-.4458c.25728-2.96124 1.3705-5.77669 3.1958-8.08428.4318.54589.8237 1.12021 1.174 1.7182.2093.35743.6687.47748 1.0262.26815.3574-.20933.4775-.66878.2681-1.0262-.2464-.42069-.5116-.83086-.7952-1.22911zm-3.3463.00012c-4.12743.73341-7.33321 4.13198-7.7748 8.35312h4.74705c.23888-3.02033 1.28884-5.9109 3.02775-8.35312z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 8.75c0-1.51878 1.2312-2.75 2.75-2.75h6.5c1.5188 0 2.75 1.23122 2.75 2.75v13.5c0 .4142-.3358.75-.75.75s-.75-.3358-.75-.75v-13.5c0-.69036-.5596-1.25-1.25-1.25h-6.5c-.6904 0-1.25.55964-1.25 1.25v13.5c0 .4142-.3358.75-.75.75s-.75-.3358-.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.75 18c-.6904 0-1.25.5596-1.25 1.25v3c0 .4142.3358.75.75.75s.75-.3358.75-.75v-2.75h2v2.75c0 .4142.3358.75.75.75s.75-.3358.75-.75v-3c0-.6904-.5596-1.25-1.25-1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.5 12.75c0-.4142.3358-.75.75-.75h.5c.4142 0 .75.3358.75.75s-.3358.75-.75.75h-.5c-.4142 0-.75-.3358-.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.25 12c-.4142 0-.75.3358-.75.75s.3358.75.75.75h.5c.4142 0 .75-.3358.75-.75s-.3358-.75-.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.5 9.75c0-.41421.3358-.75.75-.75h.5c.4142 0 .75.33579.75.75 0 .4142-.3358.75-.75.75h-.5c-.4142 0-.75-.3358-.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.25 9c-.4142 0-.75.33579-.75.75 0 .4142.3358.75.75.75h.5c.4142 0 .75-.3358.75-.75 0-.41421-.3358-.75-.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.5 15.75c0-.4142.3358-.75.75-.75h.5c.4142 0 .75.3358.75.75s-.3358.75-.75.75h-.5c-.4142 0-.75-.3358-.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.25 15c-.4142 0-.75.3358-.75.75s.3358.75.75.75h.5c.4142 0 .75-.3358.75-.75s-.3358-.75-.75-.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterpriseGlobe);
export default __webpack_public_path__ + "static/media/enterprise_globe.d1672c2e68ff218eae2e8f51cf5caaed.svg";
export { ForwardRef as ReactComponent };